export default __webpack_public_path__ + "static/blob-39-f9905e9e7ad3d20985e87aa1b07dff43.svg";